import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.css";
import App from "./App";

// index.js or App.js
window.addEventListener("unhandledrejection", (event) => {
  // Suppress the specific error from the extension
  const errorMsg = event.reason?.message || event.reason?.toString() || "";
  if (
    errorMsg.includes("M_ID") ||
    errorMsg.includes("Cannot read properties of undefined")
  ) {
    event.preventDefault(); // prevents the browser from logging it as an error
    console.warn("Ignored extension-related error:", event.reason);
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
